import angular from "angular";

let Permissions = angular.module("Permissions", []).constant(
  "Permissions",
  (() => {
    const t = {};

    /* GENERAL */
    t.EDIT_ROLES = "editRoles";
    t.VALIDATE_PASSPORT = "passportValidate";
    t.CHANGE_TEAM_PASSWORD = "changeTeamPassword";
    t.OVERRIDE_MATCH_FILTERS = "overrideMatchFilters";

    /* USERS */
    t.VIEW_USERS = "viewUsers";
    t.EDIT_USERS = "editUsers";

    t.VIEW_REPORTS = "viewReports";

    /* TRANSFERS */
    t.VIEW_ALL_TRANSFERS = "viewAllTransfers";
    t.PLAYER_TRANSFERS = "playerTransfers";
    t.MAKE_PLAYER_TRANSFER = "makePlayerTransfer";

    /* FINANCIAL */
    t.VIEW_FINANCIAL = "viewFinancial";
    t.ADD_PAYMENT = "addPaymentReason";
    t.ADD_PAYMENT_TEAM = "addPaymentTeam";
    t.ADD_PAYMENT_PLAYER = "addPaymentPlayer";
    t.VIEW_ALL_MOVEMENTS_TEAM = "viewAllMovementsTeams";
    t.VIEW_ALL_MOVEMENTS_PLAYER = "viewAllMovementsPlayers";
    t.CANCEL_PAYMENT = "cancelPayment";

    /* PLAYERS */
    t.VIEW_ALL_PLAYERS = "viewAllPlayers";
    t.ADD_PLAYER = "addPlayer";
    t.EDIT_PLAYER = "editPlayer";
    t.DELETE_PLAYER = "deletePlayer";

    /* MATCHES */
    t.ADD_MATCH = "addGame";
    t.EDIT_MATCH = "editGame";
    t.DELETE_MATCH = "deleteGame";

    /* TEAMS */
    t.VIEW_ALL_TEAMS = "viewAllTeams";
    t.ADD_TEAM = "addTeam";
    t.EDIT_TEAM = "editTeam";
    t.DELETE_TEAM = "deleteTeam";

    /* LEAGUES */
    t.VIEW_ALL_LEAGUES = "viewAllLeagues";
    t.ADD_LEAGUE = "addLeague";
    t.EDIT_LEAGUE = "editLeague";
    t.DELETE_LEAGUE = "deleteLeague";

    /* MATCH SPECIFIC */
    t.EDIT_MATCH_TARGETS = "editGameTargets";
    t.EDIT_MATCH_LEAGUES = "editGameLeagues";
    t.EDIT_MATCH_PLAYER_LEAGUE = "editGamePlayerLeague";
    t.ADD_PLAYER_TO_MATCH = "addPlayersToMatch";
    t.ADD_DISABLED_PLAYER_TO_MATCH = "addDisabledPlayers";
    t.ADD_SCORE_TO_MATCH = "addShotsToGame";
    t.REMOVE_PLAYER_FROM_MATCH = "removePlayersFromMatch";
    t.UPDATE_MATCH = "gameUpdate";
    t.MOVE_MATCH = "moveGame";
    t.CHECK_IN_PLAYER_TO_MATCH = "checkInPlayerToMatch";
    t.MATCH_PRINTS = "matchPrints";

    /* MATCH ELIMINATION ROUNDS */
    t.MATCH_ELIMINATION_ROUNDS = "olympic";
    t.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS = "addShotsToOlympic";

    /* COACHES */
    t.VIEW_ALL_COACHES = "viewAllCoaches";
    t.ADD_COACH = "addCoach";
    t.EDIT_COACH = "editCoach";
    t.DELETE_COACH = "deleteCoach";

    /* STAFF */
    t.VIEW_ALL_STAFF = "viewAllStaff";
    t.ADD_STAFF = "addStaff";
    t.EDIT_STAFF = "editStaff";
    t.DELETE_STAFF = "deleteStaff";

    /* JUDGES */
    t.VIEW_ALL_JUDGES = "viewAllJudges";
    t.ADD_JUDGE = "addJudge";
    t.EDIT_JUDGE = "editJudge";
    t.DELETE_JUDGE = "deleteJudge";

    /* TRAINERS */
    t.VIEW_ALL_TRAINERS = "viewAllTrainers";
    t.ADD_TRAINER = "addTrainer";
    t.EDIT_TRAINER = "editTrainer";
    t.DELETE_TRAINER = "deleteTrainer";

    /* TRAINING ENTRIES */
    t.VIEW_ALL_TRAINING_ENTRIES = "viewAllTrainingEntries";
    t.ADD_TRAINING_ENTRY = "addTrainingEntry";
    t.EDIT_TRAINING_ENTRY = "editTrainingEntry";
    t.DELETE_TRAINING_ENTRY = "deleteTrainingEntry";

    t.VIEW_TRAINING_CENTERS = "viewAllTrainingCenters";
    t.ADD_TRAINING_CENTER = "addTrainingCenter";
    t.EDIT_TRAINING_CENTER = "editTrainingCenter";
    t.DELETE_TRAINING_CENTER = "deleteTrainingCenter";

    return t;
  })()
).name;

export default Permissions;



// WEBPACK FOOTER //
// ./client/app/constants/permissions.js